import * as angular from 'angular';

import persistStateToServerMiddleware from './persistStateToServer.middleware';
import stateDescriptionMiddleware from './stateDescription.middleware';

export default angular.module('fp:activationswizard:common:middleware', [])
    .factory('persistStateToServerMiddleware', persistStateToServerMiddleware)
    .factory('stateDescriptionMiddleware', stateDescriptionMiddleware);